import { type BoxProps, Button, Checkbox, FormControlLabel, FormGroup, Stack, Typography } from '@mui/material'
import { CoreMyntModal } from 'components/modals/CoreMyntModal'
import type React from 'react'

interface DontShowAgain {
  show: boolean
  toggle: (dontShowAgain: boolean) => void
}

interface ConfirmForceSaveDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  show: DontShowAgain
}

interface ConfirmButtonsProps {
  onConfirm: () => void
  onClose: () => void
  onDontShowAgain: (dontShowAgain: boolean) => void
}

const ConfirmButtons =
  ({ onClose, onConfirm, onDontShowAgain }: ConfirmButtonsProps) =>
  (Wrapper: React.ComponentType<BoxProps>) => (
    <Stack direction="row" justifyContent="space-between" flex={1}>
      <FormGroup>
        <FormControlLabel
          control={<Checkbox size="small" onChange={(event) => onDontShowAgain(event.target.checked)} />}
          label={<Typography variant="subtitle1">Don't show this again</Typography>}
        />
      </FormGroup>
      <Wrapper style={{ flex: 1, justifyContent: 'flex-end' }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onConfirm}>
          Confirm
        </Button>
      </Wrapper>
    </Stack>
  )

export const useDontShowAgain = (): DontShowAgain => {
  const show = window.sessionStorage.getItem('force-save-subscription-plan-dont-show-again') !== 'true'

  const toggle = (dontShowAgain: boolean) => {
    window.sessionStorage.setItem('force-save-subscription-plan-dont-show-again', dontShowAgain ? 'true' : 'false')
  }

  return { show, toggle }
}

export const ApplyBureauSubscriptionPlansConfirm = ({ open, onClose, onConfirm, show: { show, toggle } }: ConfirmForceSaveDialogProps) => {
  if (!show) {
    return null
  }

  return (
    <CoreMyntModal
      wrapperProps={{ style: { flex: 1, maxWidth: 500 } }}
      open={open}
      onClose={onClose}
      title="Apply subscription plans"
      actions={ConfirmButtons({ onClose, onConfirm, onDontShowAgain: toggle })}
    >
      <p>Are you sure you want to apply the subscription plan for this bureau and all its clients?</p>
    </CoreMyntModal>
  )
}
